import axiosInstance from '../utils/axios';

const dayCloseService = {
  /**
   * Check the current day status for the logged-in user
   * @returns {Promise<{isDayOpened: boolean, isDayClosed: boolean, openingCash: number, closingCash: number, reportDate: string, sessionNumber: number, sessionId: number, canReopen: boolean, message: string}>}
   */
  checkDayStatus: async () => {
    const response = await axiosInstance.get('/day-close/status');
    return response.data;
  },

  /**
   * Begin a new day with opening cash
   * @param {number} openingCash - The opening cash amount
   * @returns {Promise<{id: number, reportDate: string, openingCash: number, message: string, success: boolean}>}
   */
  beginDay: async (openingCash) => {
    const response = await axiosInstance.post('/day-close/begin', { openingCash });
    return response.data;
  },

  /**
   * Close the current day session
   * @returns {Promise<{id: number, reportDate: string, openingCash: number, totalSales: number, cashSales: number, cardSales: number, upiSales: number, totalOrders: number, totalProductsSold: number, message: string, success: boolean}>}
   */
  closeDay: async () => {
    const response = await axiosInstance.post('/day-close/close');
    return response.data;
  },

  /**
   * Reopen a closed day session (same date only)
   * Creates a new session with opening cash = previous session's closing cash
   * @returns {Promise<{id: number, reportDate: string, openingCash: number, sessionNumber: number, previousSessionId: number, message: string, success: boolean}>}
   */
  reopenDay: async () => {
    const response = await axiosInstance.post('/day-close/reopen');
    return response.data;
  },

  /**
   * Get the day close summary (sales data) for current day
   * @returns {Promise<{reportDate: string, openingCash: number, totalSales: number, cashSales: number, cardSales: number, upiSales: number, totalOrders: number, totalProductsSold: number, isDayClosed: boolean, productDetails: Array}>}
   */
  getDayCloseSummary: async () => {
    const response = await axiosInstance.get('/day-close/summary');
    return response.data;
  },

  /**
   * Check if user can make sales (day is open and not closed)
   * @returns {Promise<boolean>}
   */
  canMakeSales: async () => {
    const response = await axiosInstance.get('/day-close/can-make-sales');
    return response.data;
  },

  /**
   * Get unclosed previous days
   * @returns {Promise<Array>}
   */
  getUnclosedPreviousDays: async () => {
    const response = await axiosInstance.get('/day-close/unclosed-previous-days');
    return response.data;
  },

  /**
   * Get day close reports for the current user
   * @returns {Promise<Array>}
   */
  getDayCloseReports: async () => {
    const response = await axiosInstance.get('/day-close/reports');
    return response.data;
  },

  /**
   * Get day close reports by date range
   * @param {string} startDate - Start date (YYYY-MM-DD)
   * @param {string} endDate - End date (YYYY-MM-DD)
   * @returns {Promise<Array>}
   */
  getDayCloseReportsByDateRange: async (startDate, endDate) => {
    const response = await axiosInstance.get('/day-close/reports/date-range', {
      params: { startDate, endDate }
    });
    return response.data;
  }
};

export default dayCloseService;
